import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ProgressbarService {

  public state = new BehaviorSubject('hide');

  constructor() { }

  public start() {
    this.state.next('show');
  }

  public finish() {
    this.state.next('hide');
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/progressbar/progressbar.service.ts